import { render, staticRenderFns } from "./CrazyContent.vue?vue&type=template&id=2718ef0c&scoped=true&"
import script from "./CrazyContent.vue?vue&type=script&lang=js&"
export * from "./CrazyContent.vue?vue&type=script&lang=js&"
import style0 from "./CrazyContent.vue?vue&type=style&index=0&id=2718ef0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2718ef0c",
  null
  
)

export default component.exports